import React from "react";
import { Alert, Space } from "antd";

import StatCards from "./StatCards";
import RecentActivities from "./RecentActivities";
import useMyTransactions, { formatTotals, isInProgress, isPaid, transactionAmount } from "../../../hooks/useMyTransactions";
import useCurrency from "../../../hooks/useCurrency";

/**
 * Gains du vendeur : part produit des ventes payées (dernier paiement réussi)
 * et montant des ventes encore en cours.
 */
const Earnings = () => {
    const { sales, loading, error, userId } = useMyTransactions();
    const { currency } = useCurrency();

    const paidSales = sales.filter(isPaid);
    const pendingSales = sales.filter(isInProgress);

    const stats = [
        { title: "Gains reçus", value: formatTotals(paidSales, transactionAmount, currency) },
        { title: "Ventes payées", value: paidSales.length },
        { title: "En attente de paiement", value: formatTotals(pendingSales, transactionAmount, currency) },
        { title: "Ventes en cours", value: pendingSales.length }
    ];

    return (
        <Space orientation="vertical" size={20} style={{ width: "100%" }}>
            {error && <Alert type="warning" showIcon title="Impossible de charger vos gains pour le moment." />}
            <StatCards stats={stats} loading={loading} />
            <RecentActivities
                title="Détail des ventes payées"
                transactions={paidSales}
                loading={loading}
                userId={userId}
            />
        </Space>
    );
};

export default Earnings;
